import { useTranslation } from "react-i18next";
import { PlayCircle } from "lucide-react";
import { useWizard } from "./WizardProvider";

export function TourLauncherButton({ compact }: { compact?: boolean } = {}) {
  const { i18n } = useTranslation();
  const { startTour } = useWizard();
  const isEn = i18n.language.startsWith("en");
  return (
    <button
      type="button"
      onClick={() => startTour()}
      className={
        compact
          ? "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs bg-dorado-50 border border-dorado-200 text-dorado-700 rounded hover:bg-dorado-100 transition"
          : "inline-flex items-center gap-2 px-4 py-2 text-sm bg-dorado-50 border border-dorado-200 text-dorado-700 rounded-md hover:bg-dorado-100 transition shadow-sm"
      }
    >
      <PlayCircle size={compact ? 12 : 14} />
      {isEn ? "Take the tour" : "Tomar el tour"}
    </button>
  );
}
